<script>
  import { HighlightAuto } from "svelte-highlight";
  import Highlight from "svelte-highlight";
  import atomOneDark from "svelte-highlight/src/styles/atom-one-dark";
  import typescript from "svelte-highlight/src/languages/typescript";
  import javascript from "svelte-highlight/src/languages/javascript";
  import vbscript from "svelte-highlight/src/languages/vbscript";
import { dataset_dev, update_slot_spread } from "svelte/internal";

  const code = ".body { padding: 0; margin: 0; }";
  const bulmaCode = '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bulma@0.9.3/css/bulma.min.css">';
  

const introCode = `// getJSON is a javascript function that turns that gross string of text we saw earlier 
//   into an object or list that we can loop through
// The resulting object is the variable 'data', which we pass into our function
$.getJSON( "https://api.are.na/v2/channels/YOURCHANNEL/contents", function( data ) {

  // Create an empty array which will store only the data we need
  var items = [];
  // For each item in the "contents", make a new list element with an image and the title
  $.each( data.contents, function( key, val ) {
    // For every element in the JSON file has a key and a value.
    // The key in this case, is just a number, representing the placement of each block in your channel
    // The value is the actual data of the block.  To get the url, we just do val.image.display.url
    items.push( "<li id='" + key + "'>" + "<img src='" + val.image.display.url + "' /> <p>" + val.title + "</p></li>" );
  });

  // Make a new UL (unordered list)
  // Populate it with the list elements we created above
  // Add this new unordered list to #listarea
  $( "<ul/>", {
    "class": "my-portfolio-list",
    html: items.join( "" )
  }).appendTo( "#listarea" );
});`;

const introHTML = '';
const introHTML2 = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bulma@0.9.3/css/bulma.min.css">
    <link rel="stylesheet" href="./style.css">
    <script src="https://code.jquery.com/jquery-3.6.0.min.js" integrity="sha256-/xUj+3OJU5yExlq6GSYGSHk7tPXikynS7ogEvDej/m4=" crossorigin="anonymous"></\script>
    <title>My Portfolio</title>
</head>
<body>
    <section class="section">
        <div class="container">
            <div class="columns is-multiline is-centered">
                <div class="column is-half" id="listarea"><!-- WHERE THE LIST WILL GO --></div>
            </div>
        </div>
    </section>
    
    <script src="./index.js"><\/script>
</body>
</html>`;
</script>

<svelte:head>
  {@html atomOneDark}
</svelte:head>

<main class="night">
  <div class="section-header">
    <p>INTRO</p>
  </div>
  <section>
    <div class="columns rs-section">
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">How To Make A Website With Are.na</p>
          <p class="rs-sub">A Tutorial By Spiritual Engineering</p>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">Topics Covered</p>
          <div class="columns is-mobile">
            <div class="column">
              <p class="rs-sub">API Requests</p>
              <p class="rs-sub">Github</p>
            </div>
            <div class="column">
              <p class="rs-sub">Hosting</p>
              <p class="rs-sub">Javascript</p>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">You Will Need</p>
          <div class="columns is-mobile">
            <div class="column is-one-third">
              <p class="rs-sub">
                <a target="_blank" href="https://code.visualstudio.com/"
                  >A Text Editor</a
                >
              </p>
              <p class="rs-sub">
                <a target="_blank" href="https://desktop.github.com/"
                  >Github Desktop App</a
                >
              </p>
              <p class="rs-sub">
                <a target="_blank" href="http://are.na">Are.na Account</a>
              </p>
            </div>
            <div class="column">
              <p class="rs-sub">Basic Understanding of HTML</p>
              <p class="rs-sub">
                <a target="_blank" href="http://github.com">Github Account</a>
              </p>
              <p class="rs-sub">
                <a target="_blank" href="https://app.netlify.com/signup"
                  >Netlify Account</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="section-header">
    <p>ARE.NA SETUP</p>
  </div>

  <section>
    <div class="columns rs-section">
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">Set Up Are.na Account</p>
          <p class="rs-sub">
            Sign up on <a target="_blank" href="http://are.na">Are.na</a> and create a new channel.
            You can call it whatever you'd like.
          </p>
        </div>
      </div>
      <div class="column">
        <div class="rs-img">
          <img src="img/new-channel.png" alt="" />
        </div>
      </div>
    </div>

    <div class="columns rs-section">
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">Add Your Content!</p>
          <p class="rs-sub">
            You can think of this channel as your storage area for all content
            that can appear on the site.
          </p>
          <br />
          <p class="rs-sub">Are.na can store text, images, even PDFs.  This tutorial only covers displaying images, so only upload those for now.</p>
        </div>
      </div>
      <div class="column">
        <div class="rs-img">
          <img src="img/channel-new-blocks.png" alt="" />
        </div>
      </div>
    </div>
  </section>

  <div class="section-header">
    <p>GITHUB SETUP</p>
  </div>

  <section>
    <div class="columns rs-section">
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">Set Up Github Repository</p>
          <p class="rs-sub">
            Assuming you already signed up on <a target="_blank" href="http://github.com"
              >Github</a
            >, let's go ahead and make a new repo.
          </p>
          <br />
          <p class="rs-sub">
            Be sure to give it a fun name and check the box for "Add a README
            file".
          </p>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="rs-img">
          <img src="img/create-repo.png" alt="" />
        </div>
      </div>
      <div class="column">
        <div class="rs-img">
          <img src="img/name-repo.png" alt="" />
        </div>
      </div>
    </div>

    <div class="columns rs-section">
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">Open In Desktop App</p>
          <p class="rs-sub">
            To make this tutorial as approachable as possible, we will not be
            using command-line tools. Just click "Set up in Desktop" to download
            the repo onto your computer.
          </p>
          <br />
          <p class="rs-sub">
            Your Github Desktop app should open up. You can click "Clone" to
            begin the download process (should only take a few seconds).
          </p>
          <br />
          <p class="rs-sub">
            Once completed, click "Open in Visual Studio Code".
          </p>
        </div>
      </div>
      <div class="column">
        <div class="rs-img">
          <img src="img/open-in-desktop.png" alt="" />
        </div>
        <div class="rs-img">
          <img src="img/open-in-vscode.png" alt="" />
        </div>
      </div>
    </div>
  </section>

  <div class="section-header">
    <p>VSCODE SETUP</p>
  </div>

  <section>
    <div class="columns rs-section">
      <div class="column is-two-thirds">
        <div class="rs-card">
          <p class="rs-title">Now The Fun Part!</p>
          <p class="rs-sub">
            Let's start coding! To make our lives easier, we will make this site
            in pure HTML and javascript/JQuery. There are definitely easier/more
            elegant ways to make an Are.na site, but for our purposes, let's
            stick with the basics.
          </p>
          <br />
          <p class="rs-sub">Start with an <code>index.html</code> file, <code>index.js</code> file, and <code>style.css</code> file.  You can add this link to use jquery:</p>
          <Highlight language={javascript} code='<script src="https://code.jquery.com/jquery-3.6.0.min.js" integrity="sha256-/xUj+3OJU5yExlq6GSYGSHk7tPXikynS7ogEvDej/m4=" crossorigin="anonymous"></script>' />
          <br />
          <p class="rs-sub">Pro tip: you can type '!' and hit enter to create the html template.  Your index should look something like this:</p>
        </div>
      </div>
      <div class="column">
        <div class="rs-img">
          <img src="img/folder-structure.png" alt="" />
        </div>
      </div>
    </div>

    <div class="columns rs-section">
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">A Quick Note On Styling</p>
          <p class="rs-sub">
            For this tutorial, I'll be showing you how to format your site with the very easy to use <a target="_blank" href="http://bulma.io">Bulma</a> framework.  Add the following line to the {'<head></head>'} of your index.html file.
          </p>
          <!-- <p><code>{bulmaCode}</code></p> -->
          <Highlight language={javascript} code='<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bulma@0.9.3/css/bulma.min.css">' />
          <br />
          <p class="rs-sub">
            Bulma is a pre-written styling system based on a flexbox (aka column-based) layout.  To make a row, simply make a div with class "columns".
          </p>
          <Highlight language={javascript} code='<div class="columns">
</div>
            ' />
          <br />
          <p class="rs-sub">
            To make a 3-column grid, just add three divs with class "column" inside.
          </p>
          <HighlightAuto code='<div class="columns">
  <div class="column">
    Column 1
  </div>
  <div class="column">
    Column 2
  </div>
  <div class="column">
    Column 3
  </div>
</div>' />
        </div>
      </div>
      <div class="column">
        <div class="rs-img">
          <img src="img/bulma-demo.png" alt="" />
        </div>
        <div class="rs-card">
            <p class="rs-sub">Resulting code above (not very exciting, but keep in mind this took almost zero effort)!  Bulma rocks.</p>
        </div>
      </div>
    </div>
  </section>

  <div class="section-header">
    <p>THE API</p>
  </div>

  <section>
    <div class="columns rs-section">
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">
            A Look at the Are.na API
          </p>
          <p class="rs-sub">
            Are.na is essentially a content storing and organization service.  The site keeps meticulous track of all types of content that users upload.  Lucky for us, we can use that data and present it on our own site!
          </p>
          <br>
          <p class="rs-sub">The <a target="_blank" href="https://dev.are.na/documentation/channels">Are.na API</a> documentation page offers a plethora of information about how to access specific types of data.</p>
          <br>
          <p class="rs-sub">We will be specifically looking at the CONTENTS of the Are.na channel we made earlier.</p>
          <br>
          <p class="rs-sub">Take a look at the image here.  The example request tells us that we will GET data from a given url. </p>
        </div>
      </div>
      <div class="column">
        <div class="rs-img">
          <img src="img/api-info.png" alt="">
        </div>
      </div>
    </div>

    <div class="columns rs-section">
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">
            A Closer Look at the Are.na API
          </p>
          <p class="rs-sub">
            Let's examine the link Are.na gives us in the example request. <a target="_blank" href="https://api.are.na/v2/channels/arena-influences/contents">Click here to view.</a>
          </p>
          <br>
          <p class="rs-sub">Scary, isn't it?  Not quite...You're looking at a JSON file!  Think of this as a super organized list of information about an Are.na channel, like the name, date of upload, and even direct links the images.</p>
          <br>
          <p class="rs-sub">Copy all of that text and paste it into this <a target="_blank" href="https://jsonformatter.curiousconcept.com/">JSON Formatter</a> to see a prettier version, or just look at the image version here.</p>
          <br>
          <p class="rs-sub"></p>
        </div>

        <div class="rs-card">
          <p class="rs-title">
            Understanding JSON
          </p>
          <p class="rs-sub">
            As you can see, JSON is basically just nested "objects".  This particular JSON file returns an array (aka a list) of Are.na blocks.  To get the title of the first block, we can just ask for:
          </p>
          <Highlight language={javascript} code="contents[0].title" />
          <br>
          <p class="rs-sub">Note that arrays in JSON typically start at zero rather than one.  For another example, if we wanted to get the url of the image in the third block, we can write: </p>
          <Highlight language={javascript} code="contents[2].image.original.url" />
          <br>
          <p class="rs-sub">For our purposes, we don't need all of this data in the JSON file.  We only need the title and the image URL to display on our site.</p>
        </div>
      </div>
      <div class="column">
        <div class="rs-img">
          <img src="img/formatted-json.png" alt="">
        </div>
      </div>
    </div>
  </section>

  <div class="section-header">
    <p>PUTTING IT TOGETHER</p>
  </div>

  <section>
    <div class="columns rs-section">
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">
            Still with us?
          </p>
          <p class="rs-sub">So far, all we've done is signed up for services and read through lines and lines of JSON text.  That was the hard part!</p>
          <br>
          <p class="rs-sub">
            Now that we know what data to look for, we can start to use it and display it on our site.
          </p>
          <br>
          <p class="rs-sub">
            Right now, your <code>index.html</code> file should look something like this:
          </p>
        </div>
      </div>
    </div>
    <div class="columns rs-secti">
      <div class="column">
        <div class="rs-card">
          <Highlight language={vbscript} code={introHTML2} />
          <br>
          <p class="rs-sub">
            If you made it this far, you're in a great spot... it's time to start editing <code>index.js</code>
          </p>
        </div>
      </div>
    </div>

    <div class="columns rs-section">
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">
            Fetching Data
          </p>
          <p class="rs-sub">
            Assuming you have added the JQuery script and the index.js script to your page, you are now ready to begin pulling data from your channel.
          </p>
          <br>
          <p class="rs-sub">
            Copy the code below into <code>index.js</code> and replace YOURCHANNEL with the URL version of your channel.  Typically it is just the name of your channel with dashes instead of spaces.
          </p>
          <br>
          <p class="rs-sub">
            Now find your index.html file and open it up in a browser of your choice!
          </p>
        </div>
      </div>
      <div class="column">
        <div class="rs-img">
          <img src="img/title-demo.png" alt="">
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="rs-card">
          <Highlight language={javascript} code={introCode} />
        </div>
      </div>
    </div>

    <div class="columns rs-section">
      <div class="column">
        <div class="rs-card">
          <p class="rs-title">
            Boom
          </p>
          <p class="rs-sub">
            Wow!  Looking good!  With just a few lines of code, you managed to load in images from Are.na right onto your own website!
          </p>
          <br>
          <p class="rs-sub">
            If you want to change the titles, feel free to go back into your Are.na channel and change em up.  Be sure to refresh your site to view the changes.
          </p>
          <br>
          <p class="rs-sub">
            But we aren't done yet (unless you want to be)!  Let's try to make some styling changes to make our site really feel like a portfolio site.
          </p>
        </div>
      </div>
      <div class="column">
        <div class="rs-img">
          <img src="img/site-first-pass.png" alt="">
        </div>
      </div>
    </div>
  </section>


</main>

<style>
  /* .night {
    color: white;
  }
  .rs-title {
    color: white;
  } */
  code{
    background-color: #0f1218;
    color: #afe6fc;
    /* font-size: 0.575em; */
  }
</style>
